<template>
  <div class="mutil-animation">
    <MutilAnimationItem v-for="(item, index) in result" :key="index + '_' + item.id" :cardResult="item" />
  </div>
</template>
<script>
import MutilAnimationItem from "./MutilAnimationItem.vue";

export default {
  name: "MutilAnimation",
  components: { MutilAnimationItem },
  props: {
    cardResult: { type: Array, required: true }
  },
  data() {
    return { result: [], timeoutTimer: null };
  },
  watch: {
    cardResult: {
      immediate: true,
      handler(array) {
        const vm = this;
        this.result = [];
        const clone = JSON.parse(JSON.stringify(array));
        const pick = () => {
          if (clone.length === 0) {
            this.timeoutTimer = setTimeout(() => {
              vm.$emit("animationEnd");
            }, 1000);
            return;
          }
          const el = clone.shift();
          vm.result.push(el);
          setTimeout(pick, 100);
        };
        setTimeout(pick, 100);
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.emitAnimationEnd, { once: true, capture: true });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.emitAnimationEnd);
    clearTimeout(this.timeoutTimer);
  },
  methods: {
    emitAnimationEnd() {
      this.$emit("animationEnd");
    }
  }
};
</script>
<style lang="less" scoped>
.mutil-animation {
  height: 100%;
  transform: translateZ(1px);
  position: relative;
  background: url("~@/assets/zs_imgs/ck-mutil-bg.png") center / cover no-repeat;
  display: grid;
  grid-template-columns: repeat(10, 60px);
  justify-items: center;
  justify-content: center;
}
</style>
